export default function Logo({ className = "w-9 h-9" }) {
    return (
        <svg viewBox="0 0 48 48" className={className} fill="none" aria-label="AusResearch logo">
            <path d="M24 3 42 13.5v21L24 45 6 34.5v-21L24 3z" stroke="#1E3A8A" strokeWidth="2.5" fill="#F8FAFC" />
            <path d="M22.6 20.2 16.4 27.2M25.4 20.2l6.2 7M18.5 30h11" stroke="#0F172A" strokeWidth="2" strokeLinecap="round" />
            <circle cx="24" cy="17" r="3.6" fill="#0891B2" />
            <circle cx="15" cy="30" r="3.6" fill="#1E3A8A" />
            <circle cx="33" cy="30" r="3.6" fill="#1E3A8A" />
        </svg>
    );
}
